import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';

export const routes = [
  {
    path: `/best/*`,
    exact: true,
    enableLooseEtag: true,
    page: getLoadablePage((_, store) =>
      import(/* webpackChunkName: "best_car_type_subtype" */ '../pages/best-rankings/best-rankings-definition').then(
        page =>
          page.default({
            featureFlags: store?.getState()?.featureFlags,
          })
      )
    ),
    chunkName: 'best_car_type_subtype',
  },
];
